// ***NOTE*** Please preserve alphabetical order when adding new icons
export {
  faSquare,
  faCheckCircle as faCheckCircleRegular,
  faCircle as faCircleRegular,
  faDotCircle,
} from '@fortawesome/free-regular-svg-icons'
